module.exports = __webpack_public_path__ + "img/sinon.8be296aa.png";